define('Components/ProductByShop/js/ProductByShop',['hooks'],function(hooks){
   return function(){
       hooks.registerHook('productCanBeSee',function(data,callback){

           var store = data.store,product = data.product;
          // console.log(product.get('print_if_no_store'));
           if(!store && product.get('print_if_no_store') == false){
              callback();
           }
       })
       hooks.registerHook('productIsProductExpress',function(data,callback){

           var store = data.store,product = data.product;
           // console.log(product.get('print_if_no_store'));
           // if(!store && product.get('express_product') == false){
           //     callback();
           // }
       })
   } 
});
